import GroupLayout from "./GroupLayout";

const RyanLayout = () => (
  <GroupLayout
    brandName="Ryan"
    logoUrl="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/img_I_1548414124.jpg"
    groupId="10000000017"
    headline="Ryan International Group of Institutions"
  />
);

export default RyanLayout;
